import { TabComponent, TabItemDirective, TabItemsDirective } from '@syncfusion/ej2-react-navigations';
import { ButtonPropsModel, DialogComponent } from '@syncfusion/ej2-react-popups';
import { HtmlEditor, Image, Inject, IToolbarItems, Link, NodeSelection, QuickToolbar, QuickToolbarSettingsModel, RichTextEditorComponent, Table, Toolbar, ToolbarSettingsModel } from '@syncfusion/ej2-react-richtexteditor';
import * as React from 'react';

declare var require: any
const $ = require("jquery");

const EMOJIS: { [key: string]: string }[] = [
    { content: '&#128512;', title: 'Grinning face' },
    { content: '&#128513;', title: 'Grinning face with smiling eyes' },
    { content: '&#128514;', title: 'Face with tears of joy' },
    { content: '&#128515;', title: 'Smiling face with open mouth' },
    { content: '&#128516;', title: 'Smiling face with open mouth and smiling eyes' },
    { content: '&#128517;', title: 'Smiling face with open mouth and cold sweat' },
    { content: '&#128518;', title: 'Smiling face with open mouth and tightly-closed eyes' },
    { content: '&#128519;', title: 'Smiling face with halo' },
    { content: '&#128520;', title: 'Smiling face with horns' },
    { content: '&#128521;', title: 'Winking face' },
    { content: '&#128522;', title: 'Smiling face with smiling eyes' },
    { content: '&#128523;', title: 'Face savouring delicious food' },
    { content: '&#128524;', title: 'Relieved face' },
    { content: '&#128525;', title: 'Smiling face with heart-shaped eyes' },
    { content: '&#128526;', title: 'Smiling face with sunglasses' },
    { content: '&#128527;', title: 'Smirking face"' },
    { content: '&#128528;', title: 'Neutral face' },
    { content: '&#128529;', title: 'Expressionless face' },
    { content: '&#128530;', title: 'Unamused face' },
    { content: '&#128531;', title: 'Face with cold sweat' },
    { content: '&#128532;', title: 'Pensive face' },
    { content: '&#128533;', title: 'Confused face' },
    { content: '&#128534;', title: 'Confounded face' },
    { content: '&#128535;', title: 'Kissing face' },
    { content: '&#128536;', title: 'Face throwing a kiss' },
    { content: '&#128538;', title: 'Kissing face with smiling eyes' },
    { content: '&#128539;', title: 'Face with stuck-out tongue' },
    { content: '&#128540;', title: 'Face with stuck-out tongue and winking eye' },
    { content: '&#128541;', title: 'Face with stuck-out tongue and tightly-closed eyes' },
    { content: '&#128542;', title: 'Disappointed face' },
    { content: '&#128543;', title: 'Worried face' },
    { content: '&#128544;', title: 'Angry face' },
    { content: '&#128545;', title: 'Pouting face' },
    { content: '&#128546;', title: 'Crying face' },
    { content: '&#128547;', title: 'Persevering face' },
    { content: '&#128548;', title: 'Face with look of triumph' },
    { content: '&#128549;', title: 'Disappointed but relieved face' },
    { content: '&#128550;', title: 'Frowning face with open mouth' },
    { content: '&#128551;', title: 'Anguished face' },
    { content: '&#128552;', title: 'Fearful face' },
    { content: '&#128553;', title: 'Weary face' },
    { content: '&#128554;', title: 'Sleepy face' },
    { content: '&#128555;', title: 'Tired face' },
    { content: '&#128556;', title: 'Grimacing face' },
    { content: '&#128557;', title: 'Loudly crying face' },
    { content: '&#128558;', title: 'Face with open mouth' },
    { content: '&#128559;', title: 'Hushed face' },
    { content: '&#128560;', title: 'Face with open mouth and cold sweat' },
    { content: '&#128561;', title: 'Face screaming in fear' },
    { content: '&#128562;', title: 'Astonished face' },
    { content: '&#128563;', title: 'Flushed face' },
    { content: '&#128564;', title: 'Sleeping face' },
    { content: '&#128565;', title: 'char_block' },
];
export interface ParagraphProps {
    index: number;
    setContent?: any;
    ETContent?: any;
    imageSaveUrl?: string;
    imagePath?: string;
    APIUrl?: string;
    token?: string;
    ManualId?: string;
    InternalArticleLink?: boolean;
    id?: string;
}
export interface IndexStates {
    DisplayText: string;
    Content: string;
    inputValue: string;
    ArticleIdLink: string;
    ArticleElementId: string;
    SelectedArticle: any;
    ArticleNameLink: string;
    isLoading: boolean;
    openArticleLink: boolean;
    ImageWidth: number;
    ImageHeight: number;
}
let headerParameters: any = {
    Token: ""
}
export class ParagraphEditor extends React.Component<ParagraphProps, IndexStates> {
    private rteObj: RichTextEditorComponent | any = '';
    private rteSectionEle: HTMLDivElement | any = null;
    private rteSectionRef: React.Ref<HTMLDivElement> | any = (element: any) => {
        this.rteSectionEle = element;
    };
    public selection: NodeSelection = new NodeSelection();
    public range: Range | any;
    public customBtn: HTMLElement | any;
    public dialogCtn: HTMLElement | any;
    public saveSelection: NodeSelection | any;
    public dialogObj: DialogComponent | any;
    private tabObj: TabComponent | any;
    state = {
        DisplayText: '',
        Content: '',
        inputValue: '',
        isLoading: false,
        openArticleLink: false,
        ArticleIdLink: '',
        ArticleElementId: '',
        ArticleNameLink: '',
        SelectedArticle: null,
        ImageWidth: 0,
        ImageHeight: 0
    }
    componentDidMount() {
        headerParameters.Token = this.props.token;
        if (this.props.ETContent) {
            this.props.setContent(this.props.index, this.props.ETContent, false);
            this.setState({ Content: this.props.ETContent })
            this.forceUpdate();
        }
        this.rteObj.saveInterval = 0;
        //$(document).off('click', '.InternalLink', this.linkClicked);
        $(document).off('click', '.InternalLink');
        $(document).on('click', '.linespacing-item', (e: any) => {
            e.preventDefault();
            this.lineSpacing(e.target.getAttribute('data-height'));
        });
        $(document).on('click', '.aligntable-item', (e: any) => {
            e.preventDefault();
            this.alignTable(e.target.getAttribute('data-position'));
        });
    }

    componentDidUpdate(prevProps: ParagraphProps) {
        if (this.props.ETContent && (prevProps.ETContent !== this.props.ETContent)) {
            this.setState({ Content: this.props.ETContent })
            this.forceUpdate();
        }
    }
    changeContent = (value: string) => {
        this.setState({ Content: value });
        this.rteObj.value = '';
        this.forceUpdate();
    }
    inputOnchange = (e: any) => {
        this.setState({ [e.target.name]: e.target.value } as any)
    }
    toggleAutoSave = (autosave: boolean) => {
        if (autosave) {
            //rteObj.saveInterval = 5000;
        } else {
            //rteObj.saveInterval = 0;
        }
    }
    toggleAspectRatio = (AspectRatio: boolean) => {
        let ref = this;
        if (AspectRatio) {
            $(document).on('focusout', `#RTE${ref.props.index} #imgwidth`, function (e: any) {
                let oldHeight = $(`#RTE${ref.props.index} #imgheight`).attr('aria-valuenow');
                $(`#RTE${ref.props.index} #imgheight`).val(e.target.value * oldHeight / ref.state.ImageWidth);
                //console.log(e.target.value, oldHeight, ref.state.ImageWidth, e.target.value * oldHeight / ref.state.ImageWidth);
            })
            $(document).on('focusin', `#RTE${ref.props.index} #imgwidth`, function (e: any) {
                //console.log();
                ref.setState({ ImageWidth: Number(e.target.getAttribute('aria-valuenow')) });
            })
        } else {
            $(document).off('focusout focusin', `#RTE${ref.props.index} #imgwidth`);
        }
    }
    lineSpacing = (height: string) => {
        try {
            let nodeObj: NodeSelection = new NodeSelection();
            let range: Range = nodeObj.getRange(this.rteObj.contentModule.getDocument());
            let elem: HTMLElement = nodeObj.getNodeCollection(range)[0] as HTMLElement;
            range = this.selection.getRange(document);
            this.saveSelection = this.selection.save(range, document);
            elem.parentElement!.setAttribute('style', `line-height: ${height};`);
            this.rteObj.formatter.saveData();
            this.rteObj.formatter.enableUndo(this.rteObj);
        } catch (e) { console.error("lineSpacing", e) }
    }
    alignTable = (position: string) => {
    }


    handleInputChange = (inputValue: string) => {
        this.setState({ inputValue });
        return inputValue;
    }
    returnSelectOptionsForlLoad = (SelectOpt: any, stateName: string, value: string, label: string, Data: any) => {
        let _options: any = [];
        for (let k = 0; k < SelectOpt.length; k++) {
            _options.push({ value: SelectOpt[k][value], label: SelectOpt[k][label], Data: Data[k] });
        }
        return _options;
    };
    articleSelectOnChange = (option: any) => {
        this.setState({
            SelectedArticle: option,
            ArticleIdLink: option.value,
            ArticleNameLink: option.label
        });
    }
    private image: (string | IToolbarItems)[] = ['Replace', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-',
        'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension',
        {
            tooltipText: 'Rotate Left',
            template: '<button class="e-tbar-btn e-btn" id="roatateLeft"><span class="e-btn-icon e-icons e-rotate-left"></span>'
        },
        {
            tooltipText: 'Rotate Right',
            template: '<button class="e-tbar-btn e-btn" id="roatateRight"><span class="e-btn-icon e-icons e-rotate-right"></span>'
        }];
    private items: (string | IToolbarItems)[] = ['Bold', 'Italic', 'Underline',/* 'StrikeThrough',*/
        /*   'FontName', 'FontSize', 'FontColor', 'BackgroundColor',*/
        {
            tooltipText: 'Insert Emoticons',
            template: '<button class="e-tbar-btn e-btn" tabindex="-1" id="custom_tbar"  style="width:100%"><div class="e-tbar-btn-text" style="font-weight: 500;">&#128578;</div></button>'
        },
        ///*'LowerCase', 'UpperCase', '|',*/
        //'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
        ///*        'Outdent', 'Indent', 'SuperScript', 'SubScript', '|',*/
        //'CreateTable',
        //'CreateLink', 'Image', '|',/* 'ClearFormat',*/
        //'SourceCode', '|', 'Undo', 'Redo', '|'

    ];
    private toolbarSettings: ToolbarSettingsModel = {
        items: this.items,
    };
    private quickToolbarSettings: QuickToolbarSettingsModel = {
        image: this.image,
    }
    private imageSettings = {
        saveUrl: this.props.imageSaveUrl,
        path: this.props.imagePath
    };
    private onToolbarClick(e: any): void {
        try {
            let nodeObj: NodeSelection = new NodeSelection();
            let range: Range = nodeObj.getRange(this.rteObj.contentModule.getDocument());
            //(rteObj.contentModule.getEditPanel() as HTMLElement).focus();
            range = this.selection.getRange(document);
            this.saveSelection = this.selection.save(range, document);
        } catch (e) { console.error(e, "onToolbarClick"); }
    }
    imageUploadSuccess = (args: any) => {
        var result = JSON.parse(args.e.currentTarget.response).LiveRes;
        if (result.DocName != null) {
            args.file.name = result.DocName;
            let filename: any = document.querySelectorAll(".e-file-name")[0];
            filename.innerHTML = args.file.name.replace(document.querySelectorAll(".e-file-type")[0].innerHTML, '');
            filename.title = args.file.name;
        }
    }
    //#region emojis
    public dlgButtons: ButtonPropsModel[] = [{ buttonModel: { content: "Insert", isPrimary: true }, click: this.onInsert.bind(this) },
    { buttonModel: { content: 'Cancel' }, click: this.onCancel }];
    public header: string = 'Insert Emoticons';
    public target: Element = this.rteSectionEle;
    public height: string | number = 'auto';


    public onCreate(): void {
        try {
            this.customBtn = document.getElementById('custom_tbar') as HTMLElement;
            this.customBtn.onclick = (e: Event) => {
                (this.rteObj.contentModule.getEditPanel() as HTMLElement).focus();
                this.dialogObj.element.style.display = '';
                this.range = this.selection.getRange(document);
                this.saveSelection = this.selection.save(this.range, document);
                this.dialogObj.content = this.tabObj.element;
                this.dialogObj.show();
            };
        } catch (e) { console.error(e, "onCreate"); }
    }


    public dialogCreate(): void {
        this.dialogCtn = this.tabObj.element;
        this.dialogCtn.onclick = (e: Event) => {
            let target: HTMLElement = e.target as HTMLElement;
            let activeEle: Element = this.dialogObj.element.querySelector('.char_block.e-active');
            if (target.classList.contains('char_block')) {
                target.classList.add('e-active');
                if (activeEle) {
                    activeEle.classList.remove('e-active');
                }
            }
        };
    }
    public onInsert(): void {
        let activeEle: Element = this.dialogObj.element.querySelector('.char_block.e-active');
        if (activeEle) {
            if (this.rteObj.formatter.getUndoRedoStack().length === 0) {
                this.rteObj.formatter.saveData();
            }
            this.saveSelection.restore();
            this.rteObj.executeCommand('insertText', activeEle.textContent);
            this.rteObj.formatter.saveData();
            this.rteObj.formatter.enableUndo(this.rteObj);
        }
        this.dialogOverlay();
    }

    public dialogOverlay(): void {
        let activeEle: Element = this.dialogObj.element.querySelector('.char_block.e-active');
        if (activeEle) {
            activeEle.classList.remove('e-active');
        }
        this.dialogObj.hide();
    }

    public onOpen(): void {
        this.tabObj.refresh();
    }

    public onCancel(): void {
        let activeEle: Element = (this as any).element.querySelector('.char_block.e-active');
        if (activeEle) {
            activeEle.classList.remove('e-active');
        }
        (this as any).hide();
    }

    public actionCompleteHandler(e: any): void {
        try {
            if (e.requestType === 'SourceCode') {
                this.rteObj.getToolbar().querySelector('#custom_tbar').parentElement.classList.add('e-overlay');
            } else if (e.requestType === 'Preview') {
                this.rteObj.getToolbar().querySelector('#custom_tbar').parentElement.classList.remove('e-overlay');
            }
        } catch (e) {
            console.error("actionCompleteHandler", e)
        }
    }

    //#endregion
    render() {
        let headerText: any = [{ text: "&#128578;" }, { text: "&#128053;" }];
        let emojisItems = EMOJIS.map(function (smiley: any) {
            return (
                <div className='char_block' title={smiley.title} dangerouslySetInnerHTML={{ __html: smiley.content }}></div>
            );
        });
        return (
            <div className='control-pane'>
                <div className='control-section e-rte-custom-tbar-section' id="rteCustomTool">
                    <div className='rte-control-section' ref={this.rteSectionRef} id='rteSection'>
                        <RichTextEditorComponent
                            key={'RTE' + this.props.index}
                            ref={(scope: any) => { this.rteObj = scope }}
                            toolbarSettings={this.toolbarSettings}
                            insertImageSettings={this.imageSettings}
                            toolbarClick={this.onToolbarClick.bind(this)}
                            quickToolbarSettings={this.quickToolbarSettings}
                            change={(e: any) => {
                                this.props.setContent(this.props.index, e.value, true);
                            }}
                            actionComplete={this.actionCompleteHandler.bind(this)}
                            imageUploadSuccess={this.imageUploadSuccess}
                            id={"RTE" + this.props.id}
                            created={this.onCreate.bind(this)}
                        >
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: this.props.ETContent
                                }}
                            />
                            <Inject services={[HtmlEditor, Toolbar, Image, Link, QuickToolbar, Table]} />
                        </RichTextEditorComponent>
                        <DialogComponent id='customTbarDlg' ref={(scope) => { this.dialogObj = scope }}
                            buttons={this.dlgButtons} overlayClick={this.dialogOverlay.bind(this)} header={this.header} visible={false}
                            showCloseIcon={false} width='43%' target={'#rteSection'} height={this.height} open={this.onOpen.bind(this)} isModal={true}>
                        </DialogComponent>
                        <div id="tabControl" style={{ display: 'none' }}>
                            <TabComponent id='defaultTab' ref={(tab) => { this.tabObj = tab; }} created={this.dialogCreate.bind(this)}>
                                <TabItemsDirective>
                                    <TabItemDirective header={headerText[0]}
                                        content='#rteEmoticons-smiley' />
                                </TabItemsDirective>
                            </TabComponent>
                        </div>
                        <div id="rteSpecial_char" style={{ display: 'none' }}>
                            <div id='rteEmoticons-smiley'>
                                {emojisItems}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
